import React from 'react';
import { Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Block from '../Block';
import DualAxisColumnChart from '../charts/DualAxisColumnChart';
import { useGetDashboardLocationStatusQuery } from '../../api/dashboardApiSlice';
import { Loader } from '../components';

const MAUByLocationsStatus = ({filter, ...props}) => {
  const { t } = useTranslation();
  const {data = [], isSuccess, isLoading, isError, refetch} = useGetDashboardLocationStatusQuery(filter)
  const loaderProps = { success: (!isLoading && isSuccess), error: (!isLoading && isError), retry: refetch }
  const categories = data.map((x) => (x.location_status))
  const mau = data.map((x) => (x.locations_uu_30_days))
  const consent_rate = data.map((x) => (100 * x.locations_uu_30_days / x.consented_devices ))

  return (
    <Block  title={t('publisher.maus_by_location_status')} {...props}>
      <Loader {...loaderProps} key="table" title="table">
        <DualAxisColumnChart data={
            {
              "categories": categories,
              "series": [
                {
                  "name": "MAU",
                  "data": mau
                },
                {
                  "name": "% of consented devices",
                  "data": consent_rate
                }
              ]
            }
          }/>
      </Loader>
    </Block>
  )
}

export default MAUByLocationsStatus
